function apiOrigin() {
    if (typeof window !== 'undefined' && window.__RUNTIME_CONFIG__?.REACT_APP_API_URL) {
        return window.__RUNTIME_CONFIG__.REACT_APP_API_URL;
    }
    if (process.env.REACT_APP_API_URL) {
        return process.env.REACT_APP_API_URL;
    }
    return 'http://localhost:8000';
}

function isLocalhostUrl(url) {
    try {
        const host = new URL(url).hostname.toLowerCase();
        return host === 'localhost' || host === '127.0.0.1' || host === '[::1]';
    } catch {
        return false;
    }
}

/** True when running `npm start` against a local backend (not production). */
export function isLocalDevEnvironment() {
    return process.env.NODE_ENV === 'development' && isLocalhostUrl(apiOrigin());
}
